import React, { useEffect, useRef } from 'react';

// Inline trailer playback - the film previews live on StarView Open Connect
// (drmmedia edge), so they play right here instead of dumping the visitor
// into a raw new tab. Keyboard accessible: Escape closes, focus lands on
// the close button.
export default function TrailerModal({ title, src, onClose }) {
  const closeRef = useRef(null);
  useEffect(() => {
    closeRef.current?.focus();
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => { window.removeEventListener('keydown', onKey); document.body.style.overflow = ''; };
  }, [onClose]);

  if (!src) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={`${title} trailer`}
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(4,4,15,0.92)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
    >
      <div onClick={(e) => e.stopPropagation()} style={{ width: 'min(960px, 100%)', position: 'relative' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <strong style={{ color: '#fff', fontSize: 16 }}>{title}</strong>
          <button
            ref={closeRef}
            onClick={onClose}
            aria-label="Close trailer"
            style={{ background: 'transparent', color: '#fff', border: '1px solid rgba(255,255,255,0.4)', borderRadius: 999, width: 34, height: 34, fontSize: 16, cursor: 'pointer' }}
          >
            ✕
          </button>
        </div>
        <video
          src={src}
          controls
          autoPlay
          playsInline
          style={{ width: '100%', maxHeight: '78vh', borderRadius: 12, background: '#000', display: 'block' }}
        />
      </div>
    </div>
  );
}
